import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest, makePutRequest } from 'utils/api'
import urls from 'utils/urls'
import { convertToMuiDate } from 'utils/helpers'

export default function EditOperationForm({ setOperations, params, setSelected, operations }) {
  const [open, setOpen] = useState(true)

  useEffect(() => {}, [])

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      id: params[0].id,
      IdMaintenanceplan: params[0].IdMaintenanceplan,
      EstimatedDate: params[0].EstimatedDate ? convertToMuiDate(params[0].EstimatedDate) : '',
      OperationType: params[0].OperationType,
      MaintenanceOperation: params[0].MaintenanceOperation,
      EstimatedCost: params[0].EstimatedCost,
      EstimatedTime: params[0].EstimatedTime,
    },
  })

  const handleClose = () => {
    setSelected(false)
    reset()
    setOpen(false)
  }

  const onSubmit = async (data) => {
    const response = await makePutRequest(
      urls.crudEntretienRealiserOperations + `${data.id}/`,
      data,
      {},
      true,
    )

    if (response.status === 200) {
      let id = response.data.id
      const filteredOperations = operations.results.filter((v) => v.id !== id)
      const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
        a.id > b.id ? 1 : -1,
      )

      setOperations((operations) => ({
        ...operations,
        results: updatedOperations,
      }))
      handleClose()
    }
  }

  return (
    <>
      {/* <CustomButton onClick={handleClickOpen}>créer</CustomButton> */}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Modifier Oepration</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="OperationType"
              label="Type opération"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="MaintenanceOperation"
              label="Désignation opérations"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="EstimatedDate"
              label="Date estimé"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="EstimatedCost"
              label="Coût estimé"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="EstimatedTime"
              label="Temps estimée"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
